import React from "react";

const NavItem = ({ id, url, text, icon, isActive }) => {
  return (
    <li>
      <a
        href={url}
        className={isActive ? "active" : ""}
        id={id}
      >
        <i className={icon}></i>
        {text}
      </a>
    </li>
  );
};

export default NavItem;
